// Authentication
export const AUTH_LOGIN_URL: string = '/login';
export const AUTH_LOGOUT_URL: string = '/logout';
export const AUTH_REFRESH_TOKEN_URL: string = '/login/refresh';
export const AUTH_RECOVERY_PASSWORD_URL: string = '/login/password';
export const AUTH_RECOVERY_PASSWORD_CONFIRM_URL: string =
  '/login/password-confirm';

// Signup
export const SIGNUP_URL: string = '/signup';
export const SIGNUP_CONFIRM_CODE_URL: string = '/signup/confirm-code';
export const SIGNUP_RESEND_CODE_URL: string = '/signup/resend';
export const SIGNUP_CHECK_USER_EXISTS_URL: string = '/signup/checkUserExists';

// User
export const USER_EDIT_URL: string = '/user';
export const USER_EDIT_PHOTO_URL: string = '/user/photo';
export const USER_DEPENDENTS_LIST_URL: string = '/userDependents/';
export const USER_NEW_DEPENDENT_URL: string = '/userDependents/';
export const USER_DELETE_DEPENDENT_URL: string = '/userDependents';

// Schedule
export const SCHEDULE_LOCATIONS_URL: string = '/schedule/location';
export const SCHEDULE_APPOINTMENT_URL: string = '/schedule/appointment';
export const SCHEDULE_APPOINTMENT_TYPE_URL: string =
  '/schedule/appointment-type';
export const SCHEDULE_APPOINTMENT_DATE_URL: string =
  '/schedule/appointment-date';
export const SCHEDULE_APPOINTMENT_CANCEL_URL: string =
  '/schedule/appointment/cancel';

// Doctor
export const DOCTORS_LIST_URL: string = '/doctors';
export const DOCTORS_LIST_URL_ONLINE: string = '/doctors/location/online';

// Appointment
export const APPOINTMENTS_LIST_URL: string = '/appointment';
export const APPOINTMENTS_HISTORY_URL: string = '/appointment/history';

// Payment
export const PAYMENT_TYPE_LIST_URL: string = '/payment/medhelp/';
export const PAYMENT_CREDIT_CARD_LIST_URL: string = '/payment/credit-card/';
export const PAYMENT_NEW_CREDIT_CARD_URL: string = '/payment/credit-card';
export const PAYMENT_DELETE_CREDIT_CARD_URL: string =
  '/payment/credit-card';
export const PAYMENT_DELETE_COMPLEMENT_CREDIT_CARD_URL: string = 'cardId';

// Notifications
export const NOTIFICATIONS_LIST_URL: string = '/notifications';

// Code ande Whatsapp
export const ZIP_CODE_SEARCH_URL: string = '/zip';
export const WHATSAPP_NUMBER_URL: string = '/zap';

//Medstation link
export const MED_STATION_SITE: string = 'https://www.medstationcard.com';
export const WHATSAPP_URL: string = 'https://wa.me/';

//QrCode
export const QR_CODE_URL: string = '/qr-code';
